import { useMutation } from '@tanstack/react-query'
import { postPayoutsTransfer } from 'services/UnifiedPayoutsService'

export const useCreateTransferMutation = () => {
  return useMutation({
    mutationFn: postPayoutsTransfer,
  })
}
